import { getPaymentMethodExtraField } from '../types/paymentMethod'
import { PaymentMethodField } from '../types/paymentPageInfo'

export const extraFieldShowFilter = (field: PaymentMethodField) => field.editable && !!getPaymentMethodExtraField(field.name)
